import axios from "axios"
import Cookies from "js-cookie"
import { useAuth } from "../Component/auth/Auth"
import { baseUrl } from "../public/module/extra"

const http = axios.create({
	baseURL: baseUrl
})
const isLoggedIn = Boolean(Cookies.get("isLoggedIn"))
const token = Cookies.get("token")
if (isLoggedIn) {
	http.defaults.headers.common = { Authorization: `Bearer ${token}` }
}

http.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 401) {
			try {
				const { logout } = useAuth()
				logout()
			} catch (ex) {
				//window.location.reload()
			}

			return Promise.reject()
		}

		return Promise.reject(error)
	}
)
export default http
